import './search-tag.scss'

import classNames from 'classnames'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'

const SearchTag = ({ categoriesInObj }) => {
  const [tag, setTag] = useState([])

  useEffect(() => {
    const subcategoryUniversity = _.filter(
      categoriesInObj,
      (c) =>
        c.slug.startsWith('advanced') ||
        c.slug.startsWith('beginner') ||
        c.slug.startsWith('intermediate')
    )
    setTag(_.head(subcategoryUniversity))
  }, [categoriesInObj])

  const classNameCategory = (slug) => {
    if (slug) {
      switch (true) {
        case slug.startsWith('intermediate'):
          return 'intermediate'
        case slug.startsWith('advanced'):
          return 'advanced'
        case slug.startsWith('beginner'):
          return 'beginner'
        default:
          break
      }
    }
  }

  if (_.isEmpty(tag)) return null

  return (
    <div
      className={classNames({
        'tag-search': true,
        [`${classNameCategory(tag.slug)}`]: true,
      })}
    >
      <p>{tag.name}</p>
    </div>
  )
}

export default SearchTag
